<p-table [value]="headerFooters">
    <ng-template pTemplate="header">
        <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Language</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template>
        <tr>
            <td>{{template.id}}</td>
            <td>
                <a (click)="editSelectedPdfDocumentHeaderFooter(template)">
                    {{template.name}}
                </a>
            </td>
            <td>
                {{template.language.name}}
            </td>
        </tr>
    </ng-template>
</p-table>
